export default __webpack_public_path__ + "static/media/Vector.c2b8a9e3.png";